// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2fJQk","selects":"Documents_selects__iMTzM"};